// Reactive language hook — returns the currently active app language and
// re-renders the component whenever the user switches languages. Use this in
// components/queryFn factories so `useSuspenseQuery(catalogQuery(lang))`
// automatically re-keys on language change and there's no need for a full
// page reload.
import { useTranslation } from "react-i18next";
import { normalizeLang, type AppLang } from "@/i18n";

export function useActiveLang(): AppLang {
  const { i18n } = useTranslation();
  return normalizeLang(i18n.language);
}
